<div class="index-view">
  @if (isLoading()) {
  <app-spinner [message]="loadingMessage()" />
  } @else {
  <div class="index-header">
    <div class="title-section">
      <h1>Indici</h1>
      <p>Gestione degli indici di embedding</p>
    </div>

    @if (!hasError()) {
    <button class="btn-primary main-shadow" (click)="openNewIndexModal()">
      <span class="material-symbols-outlined">add</span>
      Nuovo Indice
    </button>
    }
  </div>

  <div class="table-card">
    <table class="modern-table">
      <thead>
        <tr>
          <th>Nome Indice</th>
          <th>Embedder</th>
          <th>Data di creazione</th>
          <th class="text-center">Azioni</th>
        </tr>
      </thead>
      <tbody>
        @if (hasError()) {
        <tr>
          <td colspan="4" class="state-cell error-state">
            <div class="state-content">
              <span class="material-symbols-outlined icon">error</span>
              <p>Si è verificato un errore durante il recupero degli indici.</p>
            </div>
          </td>
        </tr>
        }

        @else if (indexes().length === 0) {
        <tr>
          <td colspan="4" class="state-cell empty-state">
            <div class="state-content">
              <span class="material-symbols-outlined icon">folder_off</span>
              <p>Non ci sono indici da visualizzare.</p>
              <button class="btn-primary" (click)="openNewIndexModal()" style="margin-top: 1rem;">
                Crea il primo indice
              </button>
            </div>
          </td>
        </tr>
        }

        @else {
        @for (item of indexes(); track item._id) {
        <tr>
          <td class="font-bold">{{ item.name }}</td>
          <td class="font-bold">{{ item.embedder }}</td>
          <td class="text-muted">{{ item.createdAt | date:'dd/MM/yyyy - HH:mm' }}</td>
          <td class="text-center">
            <div class="action-group">
              <button class="action-btn delete" title="Elimina" (click)="openDeleteModal(item)">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </div>
          </td>
        </tr>
        }
        }
      </tbody>
    </table>
  </div>
  }
</div>